import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import { environment } from '../../environments/environment';
import { EventEmitter } from "@angular/core";
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-offer-report',
  templateUrl: './offer-report.component.html',
  styleUrls: ['./offer-report.component.css']
})
export class OfferReportComponent implements OnInit {
  dataSource;
  displayedColumns = ['sno', 'service_category', 'actions'];
  p: number = 1;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  @ViewChild('fileInput') fileInput;
  private appURL: string = environment.apiUrl;
  private uploadURL: string = environment.uploadUrl;
  public myFocusTriggeringEventEmitter = new EventEmitter<boolean>();
  myOptions: INgxMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 }
    // This will disable dates starting from tomorrow
  };
  // Initialized to specific date (09.10.2018)
  model2: any = { date: { year: 2018, month: 10, day: 9 } };
  month1: any = {};
  wbetot_exp: any;
  mbetot_exp: any;
  model: any = {};
  user: any = {};
  results: any = {};
  currentUser: any = {};
  currentOrg: any;
  sessionData: any = {};
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  certList: any = [];
  certificate: any = {};
  cert: any = {};
  contId: number;
  mask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  tinmask: any[] = [/[0-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  certmask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  userType: number;
  showLoader: boolean;
  wbe_goal: number;
  mbe_goal: number;
  dataresult: any = [];
  recordsperpage: number = 25;
  datass: any = [];
  sortOrder = 0;
  AutoProductOffer: any = [];
  overall_total_offer: number = 0;
  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _flashMessagesService: FlashMessagesService

  ) {
  }

  covenants: any = [
    { provinceID: 1 },
    { provinceID: 2 },
    { provinceID: 3 },
    { provinceID: 4 },
    { provinceID: 5 },
  ];

  openCoverages = false;
  indexSelectedCoverage = 1;

  ngOnInit(): void {
    // this.loginservice.getserviceoffered('', '7', '', '', this.model)
    //   .subscribe(
    //     data => {
    //       // alert('sss')
    //       if (data['comp_details'].length > 0) {
    //         this.AutoProductOffer = data['comp_details'];
    //       } else {
    //         this.AutoProductOffer = [];
    //       }
    //     });
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    this.model['start_date'] = '';
    this.model['end_date'] = '';
    this.model['service_category'] = '';
    this.model['end_date'] = '';
    this.model['bill_no'] = '';
    this.model['f_name'] = '';
    this.model['phone'] = '';
    // this.displayedColumns = this.columnNames.map(x => x.id);
    this.getOfferReport('');
    this.covenants.forEach((_covenants) => {
      _covenants.isExpanded = false;
    });
  }

  onDateChanged(type, event: IMyDateModel): void {
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  addvendor() {
    this.router.navigate(['add-Serviceoffered']);
  }



  getOfferReport(data) {
    this.loginservice.getOfferReport(data, this.currentUser)
      .subscribe(
        data => {
          if (data['data'].length > 0) {
            this.dataresult = data['data'];
            this.overall_total_offer = data['overall_total_offer'];
            this.certList.contractorId = this.model['Id'];
            this.certList.uid = this.currentUser['uid'];
            this.certificate = data;
            this.showLoader = false;
            let tableArr: Element[] = data['data'];
            this.dataSource = new MatTableDataSource(tableArr);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
          } else {
            this.dataresult.length = 0;
            // this._flashMessagesService.show('No Subcontractors!', { cssClass: 'alert-danger' });
            // this.router.navigate(['addlowertier']);
            this.showLoader = false;
            let tableArr: Element[] = [];
            this.dataSource = new MatTableDataSource(tableArr);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
          }
        },
        error => {
          alert('Network Error getOfferReport API');
          this.showLoader = false;
          alert('Offer Report Is Still Pending')
        });
  }


  // Angular component code
  handleClick(columnId: string, element: any) {
    switch (columnId) {
      // case 'edit':
      //   this.edit(element.vendor_id);
      //   break;
      // case 'view':
      //   this.view(element.vendor_id);
      //   break;
      case 'delete':
        this.delete(element.vendor_id);
        break;
      default:
        break;
    }
  }

  delete(service_category_id: number) {
    // Handle delete action
    // alert('delete');
    // alert(service_category_id);
    if (confirm('Deleting of this Service Offered is done from the entire system')) {
      if (confirm('Are you sure want to delete')) {
        this.loginservice.deletegridDataNew(service_category_id, 'service_category_id', 'service_offered', 'status', '1').subscribe(data => {
          this._flashMessagesService.show('Deleted Successfully', { cssClass: 'alert-success' });
          this.ngOnInit();
        },
          error => {
            alert('Error in delete');
            this.showLoader = false;
          });
      }
    }
  }

  search() {
    if (this.model['bill_no'] == '' && this.model['service_category'] == '' && this.model['start_date'] == '' && this.model['end_date'] == '') {
      return false;
    }

    if (this.model['start_date'] != '' && this.model['end_date'] == '') {
      alert('Please Select End Date');
      this._flashMessagesService.show('Please Select End Date', { cssClass: 'alert-danger' });
      return true;
    } else if (this.model['start_date'] == '' && this.model['end_date'] != '') {
      alert('Please Select Start Date');
      this._flashMessagesService.show('Please Select Start Date', { cssClass: 'alert-danger' });
      return true;
    }

    let data = {
      start_date: this.model['start_date'],
      end_date: this.model['end_date'],
      bill_no: this.model['bill_no'],
      service_category: this.model['service_category'],
    };
    this.getOfferReport(data)
  }

  reset() {
    this.model['start_date'] = '';
    this.model['end_date'] = '';
    this.model['bill_no'] = '';
    this.ngOnInit();
  }

  changeRecordPerPage(value) {
    this.recordsperpage = value;
  }

  tableToExcel(table, excelName) {
    let list: any = [];
    var exports1 = [];
    this.datass = this.dataresult;
    exports1 = this.dataresult;
    let sno = 0;
    exports1.forEach(element => {
      sno = sno + 1;
      list.push({ '#': sno, 'Customer Name': element.f_name, 'Phone': element.phone, 'Total Visit': element.total_visit, 'Total Service': element.total_service });
    });
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(list);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    XLSX.writeFile(workbook, excelName + '.xls', { bookType: 'xls', type: 'buffer' });
  }

  sortable(sort) {
    let order = ""
    if (this.sortOrder == 0) {
      order = "DESC";
      this.sortOrder = 1;
    } else {
      order = "ASC";
      this.sortOrder = 0;
    }
    let data = {
      start_date: this.model['start_date'],
      end_date: this.model['end_date'],
      bill_no: this.model['bill_no'],
      f_name: this.model['f_name'],
      phone: this.model['phone'],
      sort: sort,
      sortOrder: order
    };
    this.getOfferReport(data)
  }

  printBill(bill_no, customer_id) {
    this.loginservice.printBill(bill_no, customer_id, this.currentUser)
      .subscribe(
        data => {
          if (data) {
            this.router.navigate(['print-preview'], {
              queryParams: {
                tot_amt: JSON.stringify(data['tot_amt']),
                invoiceTotal: JSON.stringify(data['invoiceTotal']),
                model: JSON.stringify(data['model']),
                multiple_offer: JSON.stringify(data['multiple_offer']),
                chekoutArray: JSON.stringify(data['chekoutArray']),
                product_multiple_offer: JSON.stringify(data['product_multiple_offer']),
                productsTobuy: JSON.stringify(data['productsTobuy']),
                discount: JSON.stringify(data['discount']),
                bill_no: JSON.stringify(data['bill_no']),
                add_charge: JSON.stringify(data['add_charge']),
                billed_on: JSON.stringify(data['billed_on']),
                from: JSON.stringify('offerReport'),
              }
            });
          }
        }, error => { alert('Network Error printBill API'); });
  }
}



// WEBPACK FOOTER //
// ./src/app/offer-report/offer-report.component.ts